import PropTypes from 'prop-types'
import React from 'react'

import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import { REWARD_PER_BATTLE } from './constants.jsx'

import classNames from 'classnames'
import styles from './Reward.scss'


const Reward = (props) => {

    const perBattleTooltipProps = (props.perBattleTooltipId) ? {
        'data-tip': true,
        'data-for': props.perBattleTooltipId,
    } : null

    const valueClassName = classNames(styles.value, {
        [styles.value__bonus] : props.bonus,
    })

    return (
        <div className={styles.base}>
            <div className={valueClassName}>
                <IndustrialResource value={props.value} popoverId={props.valueTooltipId} custom/>
            </div>
            {props.perBattleReward && (
                <p className={styles.perBattleReward} {...perBattleTooltipProps}>
                    <span className={styles.sign}>{'+'}</span>
                    <IndustrialResource value={props.perBattleReward} small />
                    &ensp;
                    {REWARD_PER_BATTLE}
                </p>
            )}
        </div>
    )
}

Reward.propTypes = {
    value: PropTypes.number.isRequired,
    perBattleReward: PropTypes.number,
    valueTooltipId: PropTypes.string,
    perBattleTooltipId: PropTypes.string,
    bonus: PropTypes.bool,
}

export default Reward



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Reward/Reward.jsx